import {
  IApplyVoucherTopup,
  IBodyTopup,
  IPackageMethod,
  ITabGame,
  ITopupGameDetail,
  ITopupPackage,
  ITopupSelectedData
} from "@/app/interfaces/ITopup"
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react"
import { PackageAndMethod } from "./PackageAndMethod"
import { TopupOrderInfo } from "./TopupOrderInfo"
import { TopupOrderInfoMobile } from "./TopupOrderInfoMobile"
import { UpdatePhoneModal } from "./UpdatePhoneModal"
import TopupService from "@/app/services/services/TopupService"
import { useRouter } from "next/router"
import { useToast } from "@/app/components/ui/use-toast"

interface SecondStepProps {
  packageAndTab: ITopupPackage
  selectedTab: ITabGame | undefined
  handleChangeSelectedTab: (tab: ITabGame) => void
  selectedData: ITopupSelectedData
  setSelectedData: Dispatch<SetStateAction<ITopupSelectedData>>
  loading: boolean
  setLoading: Dispatch<SetStateAction<boolean>>
  extendData?: {
    alreadyGoldGift: number
    totalLimit: number
  } | null
  listPackageType: "image" | "text"
  gameDetail: ITopupGameDetail
}

export const SecondStep: FC<SecondStepProps> = ({
  packageAndTab,
  selectedTab,
  handleChangeSelectedTab,
  selectedData,
  setSelectedData,
  loading,
  setLoading,
  extendData,
  listPackageType,
  gameDetail
}) => {
  const [renderMethods, setRenderMethods] = useState<IPackageMethod[]>([])
  const [visible, setVisible] = useState(false)
  const [errorCode, setErrorCode] = useState("")
  const [applyVoucher, setApplyVoucher] = useState<IApplyVoucherTopup | null>(
    null
  )
  const [loadingVoucher, setLoadingVoucher] = useState<any>(false)
  const router = useRouter()
  const { toast } = useToast()

  useEffect(() => {
    const layoutDiv = document.getElementById("layout")
    if (layoutDiv) layoutDiv.style.overflow = "initial"
  }, [])

  const checkVoucher = async (value: string) => {
    if (!!value) {
      setLoadingVoucher(true)
      try {
        let body: IBodyTopup = {
          slug_name: String(router?.query?.slug_name),
          method: selectedData?.selectMethod?.method,
          v3_id: selectedData?.selectPackage?.v3_id,
          package_id: selectedData?.selectMethod?.item?.package_id,
          user_id: selectedData?.selectUser?.user_id,
          server_id: selectedData?.selectServer?.server_id,
          role_id: selectedData?.selectRole?.role_id,
          voucher_code: value,
          type: "check_voucher"
        }

        if (selectedData?.selectPlatform?.platform_id) {
          body = {
            ...body,
            platform: selectedData?.selectPlatform?.platform_id
          }
        }
        const res = await TopupService.submitDoTopup(body)
        if (res?.data?.errorCode === 0) {
          setApplyVoucher(res?.data?.data as unknown as IApplyVoucherTopup)
          setSelectedData({
            ...selectedData,
            voucher_code: value
          })
          setErrorCode("")
        } else {
          setErrorCode(res?.data?.message)
        }
      } catch (err: any) {
        if (err.data.errorCode === 15) {
          setVisible(true)
        } else {
          setErrorCode(err?.data?.message)
        }
      } finally {
        setLoadingVoucher(false)
      }
      setLoadingVoucher(false)
    }
  }

  useEffect(() => {
    if (
      selectedData?.selectPackage.v3_id &&
      selectedData?.selectMethod?.method
    ) {
      setErrorCode("")
      setApplyVoucher(null)
      setLoadingVoucher(false)
      setSelectedData({
        ...selectedData,
        voucher_code: ""
      })
    }
  }, [selectedData?.selectPackage.v3_id, selectedData?.selectMethod?.method])

  return (
    <div className="relative max-w-[1280px] w-full mx-auto md:mt-[64px] flex gap-[40px] lg:gap-[80px] flex-col lg:flex-row overflow-initial">
      <div className="flex-1">
        <PackageAndMethod
          packageAndTab={packageAndTab}
          selectedTab={selectedTab}
          handleChangeSelectedTab={handleChangeSelectedTab}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          setLoading={setLoading}
          loading={loading}
          renderMethods={renderMethods}
          setRenderMethods={setRenderMethods}
          extendData={extendData}
          listPackageType={listPackageType}
          gameDetail={gameDetail}
        />
      </div>
      <div className="lg:max-w-[463px] w-full hidden md:block lg:sticky lg:top-[95px] h-fit right-0">
        <TopupOrderInfo
          selectedData={selectedData}
          loadingCallingMethod={loading}
          setVisible={setVisible}
          setSelectedData={setSelectedData}
          setErrorCode={setErrorCode}
          errorCode={errorCode}
          applyVoucher={applyVoucher}
          loadingVoucher={loadingVoucher}
          checkVoucher={checkVoucher}
          setApplyVoucher={setApplyVoucher}
        />
      </div>

      <div className="block md:hidden">
        <TopupOrderInfoMobile
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          loadingCallingMethod={loading}
          renderMethods={renderMethods}
          setVisible={setVisible}
          setErrorCode={setErrorCode}
          errorCode={errorCode}
          applyVoucher={applyVoucher}
          loadingVoucher={loadingVoucher}
          checkVoucher={checkVoucher}
          setApplyVoucher={setApplyVoucher}
        />
      </div>

      {visible && (
        <UpdatePhoneModal visible={visible} setVisible={setVisible} />
      )}
    </div>
  )
}
